// src/models/servicos/EquipamentoCliente.js
export class EquipamentoCliente {
  constructor(
    id = 0,
    clienteId = 0,
    clienteNome = '',
    tipoEquipamentoId = 0,
    tipoEquipamentoDescricao = '',
    descricao = '',
    marcaId = null,
    marcaDescricao = '',
    modelo = '',
    numeroSerie = '',
    patrimonio = '',
    cor = '',
    anoFabricacao = null,
    observacao = '',
    ativo = true,
  ) {
    this.id = id;
    this.clienteId = clienteId;
    this.clienteNome = clienteNome;
    this.tipoEquipamentoId = tipoEquipamentoId;
    this.tipoEquipamentoDescricao = tipoEquipamentoDescricao;
    this.descricao = descricao;
    this.marcaId = marcaId;
    this.marcaDescricao = marcaDescricao;
    this.modelo = modelo;
    this.numeroSerie = numeroSerie;
    this.patrimonio = patrimonio;
    this.cor = cor;
    this.anoFabricacao = anoFabricacao;
    this.observacao = observacao;
    this.ativo = ativo;
  }
}
